import React, { useState } from 'react'
import { EditorState } from 'draft-js'
import { htmlImporter, htmlExporter } from '../../ReportContent/components/RichTextArea/DSConfigs'

import { BlocksHtml, ContentBlockGallery, Galleries } from '../../../../common/types/api/page'
import { WidgetTypes } from '../../../../common/types/api/report'

import styled from 'styled-components'

import { ComponentCardForm } from '../../../../common/types/cardForm'
import RichTextArea from '../../ReportContent/components/RichTextArea'

interface HtmlEditor {
    type: WidgetTypes
    config: BlocksHtml | Galleries
    configProps: any
}
export default function HtmlEditor({ formObject, onChange }: ComponentCardForm<HtmlEditor>): JSX.Element {
    const { config, type, configProps } = formObject
    let configData = config
    if(type === WidgetTypes.GALLERY){
        const columns = (config as Galleries)?.columns || []
        const colIdx = configProps?.indexColumn
        const rowIdx = configProps?.indexRow
        const row = columns && columns.length > rowIdx ? columns[rowIdx] : []
        const block = row && row.length > colIdx ? row[colIdx]: undefined
        configData = ((block && (block as ContentBlockGallery)?.content) ?? {template: undefined}) as BlocksHtml
    }
    const { template } = configData as BlocksHtml
    const [textEditorState, setTextEditorState] = useState<EditorState>(htmlImporter(template || ""))

    return (
        <Content>
            <Content style={{ flexDirection: 'row' }}>
                <HtmlContent>
                    <RichTextArea
                        title={'Type the content'}
                        value={textEditorState}
                        onChange={html => {
                            setTextEditorState(html)
                            const newTemplate = htmlExporter(html)
                            if(type === WidgetTypes.GALLERY){
                                const gallery = config as Galleries
                                const columns = gallery?.columns || []
                                const colIdx = configProps?.indexColumn
                                const rowIdx = configProps?.indexRow
                                if(
                                    columns && columns.length > rowIdx && columns[rowIdx] &&
                                    columns[rowIdx].length > colIdx && columns[rowIdx][colIdx] &&
                                    (columns[rowIdx][colIdx] as ContentBlockGallery)?.content?.template
                                ) {
                                    (columns[rowIdx][colIdx] as ContentBlockGallery).content.template = newTemplate
                                    onChange({
                                        type,
                                        config: {
                                            ...config,
                                            columns
                                        },
                                        configProps
                                    })
                                }
                                
                            } else {
                                onChange({
                                    type,
                                    config: {
                                        ...config,
                                        template: newTemplate
                                    },
                                    configProps
                                })
                            }
                        }}
                    />
                </HtmlContent>
            </Content>
        </Content>
    )
}

const HtmlContent = styled.div`
    display: inline;
    flex: 1;
    margin: 1.5%;
    background: ${({ theme }) => theme['gray-0']};
`

const Content = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 300px;
    overflow: hidden;
    background: ${({ theme }) => theme['gray-200']};
`
